var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }